import type { Dimension } from '@carboncopyco/types';
import { isDesktop } from '@carboncopyco/utils';
import { adjustScale } from './adjustScale';

export const handleDimensionChange = (
  { width: initialWidth, height: initialHeight }: Dimension,
  container: HTMLElement
) => {
  if (isDesktop) {
    const clientRect = container?.getBoundingClientRect();

    const originalWidth = initialWidth;
    const originalHeight = initialHeight;

    const targetWidth = clientRect.width;
    const targetHeight = clientRect.height;

    // Calculate scaling factors
    const widthScaleFactor = targetWidth / originalWidth;
    const heightScaleFactor = targetHeight / originalHeight;

    // Choose the smaller scaling factor to maintain aspect ratio
    const scaleFactor = Math.min(widthScaleFactor, heightScaleFactor);

    // Adjust the scale factor
    const adjustedScaleFactor = adjustScale(
      scaleFactor,
      originalWidth,
      originalHeight
    );

    return { fitFactor: adjustedScaleFactor };
  }
};
